<template>
    <div :class="['bto-sb-widget-title', {'bto-sb-widget-title-icon': showIconInTitle}]">
        <Fragment v-if="showIconInTitle">
            <span class="bto-sb-widget-title-icon bto-sb-sports-icon" :class="sportClass"></span>
            <h3>{{sportName}} | {{t(title)}}</h3>
        </Fragment>
        <h3 v-else>{{t(title)}}</h3>
        <ul class="bto-sb-market-colum">
            <li v-for="mode in modes" :key="mode.type"
                :class="{'bto-sb-market-colum-active': mode.type === smode}"
                @click="changeMode(mode.type)">
                <a href="javascript:void(0);" :title="`${t(mode.title)}`"></a>
            </li>
        </ul>
    </div>
</template>

<script>
  export default {
    name: 'WidgetHeader',
    data() {
      return {
        smode: APP_SETTINGS.settings.useLatam ? 'single' : 'multi',
        modes: [
          {
            type: 'multi',
            title: 'W.MultiView'
          },
          {
            type: 'single',
            title: 'W.SingleView'
          }
        ],
      };
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      showIconInTitle: {
        type: Boolean,
        default: false,
      },
      sportClass: {
        type: String,
        default: '',
      },
      sportName: {
        type: String,
        default: '',
      }
    },
    methods: {
      changeMode(mode) {
        this.smode = mode;
        this.$emit('modechanged', mode);
      }
    }
  };
</script>